import {
  GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS,
  GET_OVERALL_MESSAGE_SEGMENTS_FAIL,
  GET_MESSAGE_SEGMENTS_REQ,
  GET_MESSAGE_SEGMENTS_SUCCESS,
  GET_MESSAGE_SEGMENTS_FAIL,
  CREATE_MESSAGE_SEGMENT_REQ,
  CREATE_MESSAGE_SEGMENT_SUCCESS,
  CREATE_MESSAGE_SEGMENT_FAIL,
  UPDATE_MESSAGE_SEGMENT_REQ,
  UPDATE_MESSAGE_SEGMENT_SUCCESS,
  UPDATE_MESSAGE_SEGMENT_FAIL,
  DELETE_MESSAGE_SEGMENT_REQ,
  DELETE_MESSAGE_SEGMENT_SUCCESS,
  DELETE_MESSAGE_SEGMENT_FAIL,
} from "../constants/messageSegments";

import { toast } from "react-toastify";

import api from "../../services/api";

export const getAllMessageSegments =
  (skip, limit) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_MESSAGE_SEGMENTS_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.get(
        `/api/message-segments?skip=${skip || 0}&limit=${limit || 10}`,
        config
      );

      dispatch({
        type: GET_MESSAGE_SEGMENTS_SUCCESS,
        payload: { body: data?.body, skip: skip || 0, limit: limit || 10 },
      });
    } catch (error) {
      dispatch({
        type: GET_MESSAGE_SEGMENTS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const getOverallMessageSegments =
  () => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      const limit = 100;
      const getMessageSegmentsGroup = async (page) => {
        const skip = limit * (parseInt(page) - 1);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.gmBackendToken}`,
          },
        };
        const { data } = await api.get(
          `/api/message-segments?skip=${skip || 0}&limit=${limit}`,
          config
        );
        return data;
      };
      let allSegments = [];
      let totalPage = 1;
      const firstPageResult = await getMessageSegmentsGroup(1);
      if (firstPageResult?.success === true) {
        allSegments = allSegments.concat(
          firstPageResult?.body?.messageSegmentsList
        );
        totalPage =
          firstPageResult.body?.count % limit === 0
            ? firstPageResult?.body?.count / limit
            : parseInt(firstPageResult.body?.count / limit) + 1;
      }
      for (let i = 2; i <= parseInt(totalPage); i++) {
        const res = await getMessageSegmentsGroup(i);
        if (res?.success === true) {
          allSegments = allSegments.concat(res?.body?.messageSegmentsList);
        }
      }
      dispatch({
        type: GET_OVERALL_MESSAGE_SEGMENTS_SUCCESS,
        payload: allSegments,
      });

    } catch (error) {
      dispatch({
        type: GET_OVERALL_MESSAGE_SEGMENTS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const createMessageSegment =
  (messageSegmentData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: CREATE_MESSAGE_SEGMENT_REQ,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const url = "/api/message-segments";
      const { data } = await api.post(url, messageSegmentData, config);

      dispatch({
        type: CREATE_MESSAGE_SEGMENT_SUCCESS,
        payload: data?.body,
      });
      // fire event to create automation alarm for the extension
      // window.dispatchEvent(
      //   new CustomEvent('create-automation-settings', {
      //     bubbles: true,
      //     detail: {
      //       userEmail: userInfo.gmUsrEmail,
      //       automation: data?.body.automations,
      //     },
      //   })
      // );
      toast.success(data?.msg || "Message segment created successfully");
    } catch (error) {
      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      dispatch({
        type: CREATE_MESSAGE_SEGMENT_FAIL,
      });

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const updateMessageSegment =
  (messageSegmentData, messageSegmentId = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_MESSAGE_SEGMENT_REQ,
      });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const url = `/api/message-segments/${messageSegmentId}`;
      const { data } = await api.patch(url, messageSegmentData, config);

      dispatch({
        type: UPDATE_MESSAGE_SEGMENT_SUCCESS,
        payload: data?.body,
      });
      // fire event to update automation alarm for the extension
      // window.dispatchEvent(
      //   new CustomEvent("update-automation-settings", {
      //     bubbles: true,
      //     detail: {
      //       userEmail: userInfo.gmUsrEmail,
      //       automation: data?.body,
      //     },
      //   })
      // );
      toast.success(
        data?.msg || "Message segment details updated successfully"
      );
    } catch (error) {
      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      dispatch({
        type: UPDATE_MESSAGE_SEGMENT_FAIL,
      });

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

export const deleteMessageSegment =
  (messageSegmentId) => async (dispatch, getState) => {
    try {
      dispatch({ type: DELETE_MESSAGE_SEGMENT_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.delete(
        `/api/message-segments/${messageSegmentId}`,
        config
      );

      dispatch({
        type: DELETE_MESSAGE_SEGMENT_SUCCESS,
        payload: messageSegmentId,
      });

      // fire event to delete automation alarm for the extension
      // window.dispatchEvent(
      //   new CustomEvent("delete-automation-settings", {
      //     bubbles: true,
      //     detail: {
      //       userEmail: userInfo.gmUsrEmail,
      //       automationId: data?.body,
      //     },
      //   })
      // );

      toast.success("Message segment deleted successfully");
    } catch (error) {
      dispatch({
        type: DELETE_MESSAGE_SEGMENT_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };
